import type { SlateBlock } from '@atlas/renderer';

export default function isHorizontalLineBlock(block: SlateBlock) {
    return block.type === 'horizontal-line';
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('isHorizontalLineBlock', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
